<template>
    <div class="card h-100 border-radius-8 shadow">
        <div class="card-body">
            <h4 class="card-title font-poppins font-weight-extrabold color-blue font-size-14">
                {{ Lang.get('employerdashboard::shared.spreadsheet_sync_status.title') }}
            </h4>

            <div class="card-text color-dark-blue font-size-14">
                <p v-if="latestSuccessfulEmployeeImport?.data.created_at" class="m-0">
                    {{ Lang.get('employerdashboard::shared.spreadsheet_sync_status.last_import_at') }}:<br/>
                    <strong class="font-aileron-bold">
                        {{ latestSuccessfulImportDate }}
                    </strong>
                </p>

                <p v-if="importMissingForCurrentPeriod" class="mt-3 mb-0">
                    {{
                        Lang.get('employerdashboard::shared.spreadsheet_sync_status.employee_import_is_missing', {
                            period: currentPeriod,
                        })
                    }}
                    <span v-if="uploadFeatureEnabled">
                        {{ Lang.get('employerdashboard::shared.spreadsheet_sync_status.upload_file') }}
                    </span>

                    <span v-else>
                        {{
                            Lang.get('employerdashboard::shared.spreadsheet_sync_status.send_file_through_email.before_email_link')
                        }}
                        <a :href="`mailto:${employeeImportInboxEmail}`">{{ employeeImportInboxEmail }}</a>{{
                            Lang.get('employerdashboard::shared.spreadsheet_sync_status.send_file_through_email.after_email_link')
                        }}
                    </span>
                </p>

                <inertia-link
                    v-if="uploadFeatureEnabled || isAuthorizedFromScp"
                    class="btn btn-primary btn-sm font-poppins font-weight-bold btn-orange border-radius-19 px-4 mt-3"
                    :href="route('nl.employerdashboard.employees-import.uploads.create',{ company_as_uuid: companyUuid, })"
                >
                    {{ Lang.get('employerdashboard::shared.spreadsheet_sync_status.import_button') }}
                </inertia-link>

                <p v-if="isAuthorizedFromScp && !uploadFeatureEnabled"
                    class="mt-3 mb-0"
                >
                    {{ Lang.get('employerdashboard::shared.spreadsheet_sync_status.warning_feature_not_enabled') }}
                </p>

                <inertia-link
                    class="btn btn-primary btn-sm font-poppins font-weight-bold btn-orange border-radius-19 px-4 mt-3"
                    :href="route('nl.employerdashboard.employees-import.overview',
                      { company_as_uuid: companyUuid, })">
                    {{ Lang.get('employerdashboard::shared.spreadsheet_sync_status.overview_button') }}
                </inertia-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        uploadFeatureEnabled: Boolean,
        companyUuid: String,
        importMissingForCurrentPeriod: Boolean,
        employeeImportInboxEmail: String,
        latestSuccessfulEmployeeImport: Object|null,
        isAuthorizedFromScp: Boolean,
    },
    computed: {
        currentPeriod() {
            const date = new Date();

            return date.toLocaleString(
                Lang.getLocale(),
                {
                    month: 'long',
                    year: 'numeric'
                }
            );
        },
        latestSuccessfulImportDate() {
            const importDate = this.latestSuccessfulEmployeeImport
                ?.data
                ?.latest_employee_import_file
                ?.company_file
                ?.core_processed_at;

            if (importDate) {
                return new Date(importDate).toLocaleString(
                    Lang.getLocale(),
                    {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric'
                    }
                );
            }

            return '';
        }
    },
}
</script>
